import * as React from "react"
import { FlowInputCallback, FlowInputTextType, FlowQuestionId } from "types"

import InputText from "../InputText"

export interface InputCurrencyProps {
  disabled: boolean
  flowKey: FlowQuestionId
  onSubmit: FlowInputCallback
  userAnswer: any
}

const InputCurrency: React.FC<InputCurrencyProps> = ({
  disabled,
  flowKey,
  onSubmit,
  userAnswer,
}) => {
  const onSubmitFormat = ({
    flowKey,
    value,
  }: {
    flowKey: FlowQuestionId
    value: string
  }) => {
    const val = value.replace(/,/g, "")
    const display = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(parseInt(val, 10))

    onSubmit({
      flowKey,
      value: val,
      display,
    })
  }

  return (
    <InputText
      inputType={FlowInputTextType.Currency}
      maxLength={10}
      placeholder="100000"
      prefixSign="$"
      onSubmit={onSubmitFormat}
      disabled={disabled}
      flowKey={flowKey}
      userAnswer={userAnswer}
    />
  )
}

export default InputCurrency
